import type { ReactNode, ReactPortal } from 'react';
import ReactDOM from 'react-dom';

/* A portal component */
const Portal = ({
  children,
  portalContainer,
}: {
  children: ReactNode;
  portalContainer: Element;
}): ReactPortal => ReactDOM.createPortal(children, portalContainer);

export default Portal;
